import { render, staticRenderFns } from "./WtkMessage.vue?vue&type=template&id=22ff4297"
import script from "./WtkMessage.vue?vue&type=script&lang=js"
export * from "./WtkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports